import React, { useState } from 'react'
import { format } from 'date-fns'
import posthog from 'posthog-js'
import EditLeadForm from './EditLeadForm'
import styles from './LeadDashboardPage.module.css'

export default function BasicInfoSection({ lead }) {
  const [isEditing, setIsEditing] = useState(false)
  const dateDisplay = format(lead.start_date, 'MMMM d, yyyy')
  const locationDisplay = lead.address?.street || lead.address?.formatted

  const timeBetween = new Date(lead.start_date).getTime() - Date.now()
  const daysUntilEvent = Math.floor(timeBetween / (1000 * 3600 * 24))
  return (
    <div className={[isEditing ? styles.card : '']}>
      {isEditing ? (
        <EditLeadForm lead={lead} close={() => setIsEditing(false)} />
      ) : (
        <>
          {
            daysUntilEvent > 0 && (
              <p className='text-2xl mb-4 text-black font-light'>
                {daysUntilEvent} Days to go!
              </p>
            )
          }
          <p className='text-2xl text-black font-light'>
            You've requested catering service for 
            a <span className='capitalize font-bold'>{lead.occasion?.display_name || lead.occasion?.name || 'Event'} </span> 
            on <span className='capitalize font-bold'>{dateDisplay} </span> 
            for <span className='capitalize font-bold'>{lead.eaters} </span> people,
            {lead.address?.street ? " at" : " in"} <span className='capitalize font-bold'>{locationDisplay}</span>.
          </p>
          { lead.status !== 'has_proposal' ? (
            <div className='pt-4'>
              <button 
                className='btn rounded-full px-4 py-1 btn-white text-black' 
                onClick={() => {
                  setIsEditing(true)
                  posthog.capture('event_edit_opened')
                }}
              >
                Edit
              </button>
            </div>
          ) : null}
        </>
      )}
    </div>
  )
}
